import { ApplicationForm } from '../components/ApplicationForm';

/** Apply page — the intro framing + the application form (SC-001/002/003). */
export default function Apply() {
  return (
    <div className="mx-auto w-full max-w-2xl px-6 py-16 sm:py-20">
      <p className="font-display text-xs font-semibold uppercase tracking-[0.28em] text-accent-deep">
        Membership
      </p>
      <h1 className="mt-3 font-display text-3xl font-semibold uppercase tracking-[0.12em] text-ink sm:text-4xl">
        Apply to join
      </h1>
      <p className="mt-4 max-w-prose font-serif text-lg leading-relaxed text-ink">
        Membership is free and open to everyone who shares our values. There are no fees, no oaths, and no
        cover names. Just tell us who you are, affirm the values, and the board takes it from there.
      </p>

      <div className="mt-10">
        <ApplicationForm />
      </div>
    </div>
  );
}
